import { useEffect, useRef } from 'react';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import TextField from '@mui/material/TextField';

/** Defaults to the selected repo, while preserving a name the user supplied. */
export function ServiceNameField({
  formData,
  formContext,
  onChange,
  schema,
  required,
  rawErrors,
}: FieldExtensionComponentProps<string>) {
  const siblings = (formContext as { formData?: { repo?: string } } | undefined)
    ?.formData;
  const repo = new URLSearchParams(siblings?.repo?.split('?')[1]).get('repo');
  const previousRepo = useRef<string | null>();

  useEffect(() => {
    if (repo !== previousRepo.current) {
      if (!formData || formData === previousRepo.current) {
        onChange(repo || undefined);
      }
      previousRepo.current = repo;
    }
  }, [repo, formData, onChange]);

  return (
    <TextField
      fullWidth
      label={schema.title ?? 'Service Name'}
      helperText={rawErrors?.join('. ') || schema.description}
      required={required}
      error={Boolean(rawErrors?.length)}
      value={formData ?? ''}
      onChange={event => onChange(event.target.value || undefined)}
      inputProps={{ maxLength: schema.maxLength }}
    />
  );
}
